import React, { useEffect } from "react";
import { ICON_BIN, ICON_PEN } from "../../../utils/icons";
import DeleteModal from "../DeleteModal";
import { useState } from "react";
import EditItem from "./EditItem";
import { useAuthContext } from "../../../context/auth_context";
import { useItemContext } from "../../../context/item_context";
import { useUserContext } from "../../../context/user_context";
import { placeholder } from "../../../assets";
import CustomTable from "../../../utils/CustomTable";
import AddItem from "../item/AddItem";

export default function AllServices() {

      const [itemData, setItemData] = useState('');

      const {
            getFeature: { checkFeature }
      } = useAuthContext();

      const {
            openAddItem,
            openEditItem,
            serviceLoading, allServices, getServiceData,
      } = useItemContext();

      const { btoken, stoken } = useUserContext();


      function openEditModal(item) {
            setItemData(item);
            openEditItem();
      }


      useEffect(() => {
            const service = allServices?.map((item, i) => {

                  const { id, icid, item: itemName, details, real_date, supplier, category, sid, image } = item;

                  const payload = { btoken, stoken, itemId: id };
                  return (
                        {
                              sn: i + 1,
                              id,
                              real_date,
                              image: <img src={image || placeholder} alt={itemName} width="50px" className="br-md" />,
                              itemName,
                              category,
                              details,
                              supplier: supplier || 'Nil',
                              sid,
                              // timeago: timeago,

                              action:
                                    // checkFeature('item_edit') &&
                                    //       <>
                                    //       </>
                                    <h6 className="d-flex fit-content  border-bottom pointer border-success green-text text-center"
                                          onClick={(e) => openEditModal(item)}
                                    >
                                          {ICON_PEN}
                                    </h6>
                              ,
                              delete:
                                    <DeleteModal
                                          payload={payload}
                                          name={itemName}
                                          url={'deleteItem'}
                                          getDataFn={getServiceData}
                                          dataName={'Services'}
                                    >
                                          <h6 className="d-flex fit-content  border-bottom pointer border-danger red-text text-center"
                                          >
                                                {ICON_BIN}
                                          </h6>
                                    </DeleteModal>
                              // checkfeature('item_delete') &&


                        }
                  );
            });

            setDatatable({
                  ...datatable,
                  // columns: [
                  //       {
                  //             label: checkfeature('item_edit') ? 'Action' : '',
                  //             label: 'Action',
                  //             field: "action",
                  //             width: 200,
                  //       },
                  //       {
                  //             label: checkfeature('item_delete') ? 'Delete' : '',
                  //             label: 'Delete',
                  //             field: "delete",
                  //             width: 200,
                  //       },
                  // ],
                  rows:
                        service
            });
      }, [allServices]);

      useEffect(() => {
            getServiceData();
      }, []);


      const [datatable, setDatatable] = React.useState({
            columns: [
                  {
                        label: "S/N",
                        field: "sn",
                        width: 150,
                        attributes: {
                              "aria-controls": "DataTable",
                              "aria-label": "sn",
                        },
                  },
                  {
                        label: "ID",
                        field: "id",
                        width: 150,
                  },
                  {
                        label: "Date Added",
                        field: "real_date",
                        width: 150,
                  },
                  {
                        label: "Image",
                        field: "image",
                        width: 270,
                  },
                  {
                        label: "Service",
                        field: "itemName",
                        width: 270,
                  },
                  {
                        label: "Category",
                        field: "category",
                        width: 270,
                  },
                  {
                        label: "Details",
                        field: "details",
                        width: 270,
                  },
                  {
                        label: "Supplier",
                        field: "supplier",
                        width: 270,
                  },
                  {
                        label: checkFeature('item_edit') ? 'Action' : '',
                        label: 'Action',
                        field: "action",
                        width: 200,
                  },
                  {
                        label: checkFeature('item_delete') ? 'Delete' : '',
                        label: 'Delete',
                        field: "delete",
                        width: 200,
                  },
            ],
            rows: []
      });


      return (
            <>

                  <div className="">

                        <CustomTable
                              tableTitle={"All Services"}
                              loading={serviceLoading}
                              getData={getServiceData}
                              openAddModal={openAddItem}
                              addTitle={"Add Service"}
                              datatable={datatable}
                        />

                  </div>

                  {/* Add Item Modal */}
                  <AddItem />
                  {/* Add Item Modal */}

                  {/* Edit Item Modal */}
                  <EditItem
                        {...itemData}
                  />
                  {/* Edit Item Modal */}
            </>

      );
}
